/**
 * Who is signed in, as the API last said, for surfaces with no AuthContext to read: the share
 * page's Astro island signs in by the session cookie and holds no token or role (U14 found the
 * same gap for the avatar). The Save heart's GET /saved/<id>, the one authenticated call the
 * page already makes, answers `viewer: "child" | "grownup"` and records it here (U18, the
 * operator's walk 2026-10-27: a signed-in grown-up met the photo gate on the share page).
 * `useSessionKind` and `useIsChildSession` fall back to it only when no role and no child
 * name are known. No `@capacitor/*` and no app shell here: the island imports it.
 */
import { useSyncExternalStore } from "react";

export type ViewerKind = "child" | "grownup";

let viewer: ViewerKind | null = null;
const listeners = new Set<() => void>();

/** Record what an authenticated answer said (null: signed out). */
export function noteViewerKind(kind: ViewerKind | null): void {
  if (kind === viewer) return;
  viewer = kind;
  for (const l of listeners) l();
}

export function useViewerKindFromApi(): ViewerKind | null {
  return useSyncExternalStore(
    (l) => { listeners.add(l); return () => listeners.delete(l); },
    () => viewer,
    () => viewer,
  );
}

/** Test seam. */
export function __resetViewerKindForTests(): void {
  viewer = null;
  listeners.clear();
}
